/*eslint-disable*/
const axios = require("axios");
const config = require("../client_config/config");

const uploadSkinCheckImage = async (service, files, progress) => {
  let formData = new FormData();

  for (let item in service) {
    formData.append(item, service[item]);
  }

  Object.entries(files).forEach(([key, value]) => {
    formData.append(key, value);
  });

  return axios.post(
    `${config.url}/adl/skin-check-image/upload/${service.clientID}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      progress,
    }
  );
};

module.exports = {
  uploadSkinCheckImage,
};
